<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.task {
  width: 2.75rem;
  height: 3.53rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
>>> .van-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}
.task_img {
  width: 1.97rem;
  height: 1.24rem;
  margin-top: 0.2rem;
}
.close_task {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  top: 0.13rem;
  right: 0.13rem;
}
.task_title {
  font-size: 0.18rem;
  font-weight: bold;
  color: #333;
  margin-top: 0.18rem;
}
.task_tips {
  font-size: 0.14rem;
  color: #333;
  margin-top: 0.07rem;
}
.task_tips_dis {
  color: #ff3b3b;
  font-weight: bold;
}
.task_btn {
  width: 2.45rem;
  height: 0.5rem;
  font-size: 0.17rem;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 0.5rem;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 0.25rem;
  margin-top: 0.14rem;
}
/* .recommend {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}
.recommend_box {
  width: 2.55rem;
  height: 2.75rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.recommed_title {
  font-size: 0.2rem;
  color: #424242;
  font-weight: bold;
  margin-top: 0.28rem;
}
.recommend_tips {
  color: #ff514a;
  font-size: 0.18rem;
  font-weight: bold;
  margin-top: 0.1rem;
}
.recommend_more_tips {
  width: 2.15rem;
  height: 0.8rem;
  background: linear-gradient(
    180deg,
    rgba(225, 225, 225, 0.09) 0%,
    rgba(248, 248, 248, 1) 100%
  );
  margin-top: 0.15rem;
  display: flex;
  align-items: center;
}
.tips_left {
  width: 0.45rem;
  height: 0.45rem;
  background: rgba(255, 76, 76, 1);
  border-radius: 0.1rem;
  margin-left: 0.16rem;
}
.tips_right {
  margin-left: 0.1rem;
  color: #333333;
  font-weight: bold;
  font-size: 0.15rem;
}
.recomment_money {
  color: #ff514a;
  font-size: 0.22rem;
}
.recommend_btn {
  width: 2.15rem;
  height: 0.5rem;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 0.25rem;
  font-size: 0.17rem;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 0.5rem;
  margin-top: 0.15rem;
}
.task_close_img {
  width: 0.3rem;
  height: auto;
  margin-top: 0.4rem;
} */

.showBox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.task_box_img {
  width: 2.55rem;
  height: auto;
}
.task_box_close_img {
  width: 0.3rem;
  height: auto;
  margin-top: 0.4rem;
}
.taskBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.tags_img {
  width: 0.32rem;
  margin-left: 0.06rem;
}
.pro_img {
  width: 0.45rem;
  height: 0.45rem;
  position: absolute;
  left: 0.36rem;
  top: 1.44rem;
}
.pro_name {
  position: absolute;
  left: 0.91rem;
  top: 1.45rem;
  font-size: 0.15rem;
  color: #333;
  font-weight: bold;
}
.pro_money {
  position: absolute;
  left: 0.91rem;
  top: 1.66rem;
  font-weight: bold;
  color: #ff514a;
  font-size: 0.22rem;
}
.pro_btn {
  width: 1.65rem;
  height: 0.37rem;
  background: rgba(25, 28, 35, 1);
  font-size: 0.16rem;
  color: #ffd8b0;
  text-align: center;
  line-height: 0.37rem;
  border-radius: 0.25rem;
  position: absolute;
  left: 0.45rem;
  top: 2.34rem;
}
</style>

<template>
  <div class="detail_box">
    <div class="header">
      <div>
        <h3 class="h_title">贷款金额(元)</h3>
        <p class="h_money">
          {{ newDetail.amountStart }}-{{ newDetail.amountEnd }}
        </p>
      </div>
      <div>
        <h3 class="h_title">贷款期限</h3>
        <p class="h_money">{{ newDetail.timeLimit }}</p>
      </div>
    </div>
    <div class="product_tips">
      <div class="tips_flex tips_bot_border">
        <span class="tips_txt_color">日利率</span>
        <span class="tips_num_color"
          >{{ newDetail.rateStart }}-{{ newDetail.rateEnd }}</span
        >
      </div>
      <div class="tips_flex">
        <span class="tips_txt_color">放款时间</span>
        <span class="tips_num_color"
          >{{ newDetail.lendTime }}{{ newDetail.lendTimeUnit }}放款</span
        >
      </div>
    </div>
    <!-- <div class="plan">
      <div class="item">
        <p class="p_title">期限</p>
        <p class="p_info">{{newDetail.timeLimit}}</p>
      </div>
      <div class="p_line"></div>
      <div class="item">
        <p class="p_title">{{newDetail.rateUnit}}利率</p>
        <p class="p_info">{{newDetail.rateStart}}-{{newDetail.rateEnd}}</p>
      </div>
      <div class="p_line"></div>
      <div class="item">
        <p class="p_title">放款时间</p>
        <p class="p_info">{{newDetail.lendTime}}{{newDetail.lendTimeUnit}}放款</p>
      </div>
    </div> -->
    <!-- <div class="product">
      <p class="com_title"><span class="com_line"></span>产品特色</p>
      <div class="p_con"><span class="circle"></span>{{newDetail.feature}}</div>
      <div class="p_con"
           v-for="(item,index) in toArray(newDetail.feature)"
           :key="index">
        {{util.trim(item)}}
      </div>
    </div> -->
    <div class="apply">
      <p class="com_title">
        <span class="com_line"></span>完成以下流程，即可申请贷款
      </p>
      <div class="a_con">
        <div class="step">
          <span class="icon1"></span><br />
          <span>注册账号</span>
        </div>
        <!-- <div class="step"> -->
        <div class="step_line"></div>
        <!-- </div> -->
        <div class="step">
          <span class="icon2"></span><br />
          <span>下载APP</span>
        </div>
        <div class="step_line"></div>
        <div class="step">
          <span class="icon3"></span><br />
          <span>资料认证</span>
        </div>
        <div class="step_line"></div>
        <div class="step">
          <span class="icon4"></span><br />
          <span>等待下款</span>
        </div>
      </div>
    </div>
    <div class="loan">
      <p class="com_title"><span class="com_line"></span>申请条件</p>
      <div v-if="newDetail.conditions">
        <div
          class="p_con"
          v-for="(im, ix) in newDetail.conditions.split(';')"
          :key="ix"
        >
          <span class="circle"></span>{{ im }}
        </div>
      </div>

      <!-- <div class="p_con"><span class="circle"></span>年龄{{newDetail.ageLimitStart}}-{{newDetail.ageLimitEnd}}</div> -->
      <!-- <div class="p_con"
           v-for="(item,index) in change(newDetail.applyConditions)"
           :key="index"><span class="circle"></span>{{util.trim(item)}}</div> -->
    </div>
    <div class="btnBox">
      <div class="btn" @click="toLogin">一键申请</div>
    </div>

    <!-- 弹窗 -->
    <!-- <div class="shadow" v-if="isShow && orderList.length > 0"></div>
    <div class="toast" v-if="isShow && orderList.length > 0">
      <h1>推荐一款更适合您的产品</h1>
      <div class="item">
        <p class="left t_icon">
          <img :src="orderList[0].productIcon" alt="" />
        </p>

        <div style="right">
          <p>{{ orderList[0].productName }}</p>
          <p class="money">{{ orderList[0].productMoney }}</p>
        </div>
      </div>
      <div class="btn_box">
        <span class="reject" @click="toHide">残忍拒绝</span>
        <span class="submit" @click="toRouter(orderList[0].pageUrl)"
          >马上拿钱</span
        >
      </div>
    </div>
    <Loading :isShow="isShowLoading"></Loading> -->

    <!-- 新弹窗 -->
    <van-overlay :show="showCheckWindow" @click="showCheckWindow = false">
      <div class="wrapper">
        <div class="task" @click.stop>
          <img
            class="close_task"
            @click="toLoginApi"
            src="@/assets/img/vip/close_task.png"
            alt=""
          />
          <img class="task_img" src="@/assets/img/vip/img_tip.png" alt="" />
          <p class="task_title">温馨提示</p>
          <span class="task_tips">频繁申请容易导致信用不佳</span>
          <span class="task_tips"
            >建议先进行 <span class="task_tips_dis">贷前检测</span></span
          >
          <span class="task_tips">提高贷款通过率</span>
          <div @click.stop="tomember" class="task_btn">立即检测</div>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="isShow" @click="isShow = false">
      <div class="showBox">
        <div class="taskBox" v-if="orderList.length">
          <img
            @click.stop
            class="task_box_img"
            src="@/assets/img/vip/vip_detail_bg.png"
            alt=""
          />
          <img
            @click.stop
            class="pro_img"
            :src="orderList[0].productIcon"
            alt=""
          />
          <p @click.stop class="pro_name">{{ orderList[0].productName }}</p>
          <p @click.stop class="pro_money">{{ orderList[0].productMoney }}</p>
          <div @click.stop="toRouter(orderList[0].pageUrl)" class="pro_btn">
            立即申请
          </div>
          <img
            class="task_box_close_img"
            @click.stop="toHide"
            src="@/assets/img/vip/icon_close.png"
            alt=""
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "@/components/loading";
export default {
  components: {
    // Head,
    Loading,
  },
  data() {
    return {
      isShowLoading: false,
      isShow: false,
      noBack: false,
      newDetail: {},
      orderList: [],
      href: "",
      productId: "",
      content: `大家好
      审核快，放款快
      是否水电费水电费是
      地方看过的风格`,
      showCheckWindow: false,
      showProductLink: true,
      showBlackTask: false,
    };
  },
  created() {
    window.goHome = this.goHome;
  },
  mounted() {
    this.productId = this.$route.query.productId;
    this.util.title("产品详情");
    // console.log(window.history);
    // console.log(window.history.pushState);
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
    this.getNewDetail();
    this.getDetails();
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    tomember() {
      let json = {
        event_key: "h5_middlepage_recommend_click",
      };
      this.toCountPoint(json);
      this.showCheckWindow = false;
      window.location.href = this.newDetail.blackListPageUrl;
    },
    toRouter(pageUrl) {
      this.isShow = false;
      let param = {
        pageUrl: pageUrl,
      };
      if (pageUrl.indexOf("http") == "-1") {
        //跳到客户端页面——产品详情页面
        this.toProductDetail(param);
      } else {
        window.location.href = pageUrl;
      }
    },
    //调用android和ios的方法
    toProductDetail(param) {
      try {
        window.webkit.messageHandlers.toProductDetail.postMessage(param); //ios
      } catch (err) {
        window.AppJs.toProductDetail(JSON.stringify(param)); //android
      }
    },
    getDetails() {
      let param = {
        productId: this.productId,
      };
      let _this = this;
      this.$get("/app/api/v1/qualification/view", param)
        .then((res) => {
          var e = res;
          if (e.code == 200) {
            e.data.appOrderCells.map(function(item) {
              if (item.type == "product") {
                _this.orderList = item.content; //产品列表
              }
            });
          } else {
            _this.util.toast({ msg: e.msg });
          }
        })
        .catch((error) => {});
    },
    change(val) {
      if (val) {
        return val.join("|").split("|");
      }
    },
    toArray(val) {
      if (val) {
        return val.split("|");
      }
    },
    goBack() {
      if (this.noBack == false && this.orderList.length > 0) {
        this.isShow = true;
        // this.$router.replace({ path: '/vip/creditCheck' });
        //replace替换原路由，作用是避免回退死循环
      } else {
        this.isShow = false;
        this.$router.back();
      }
    },
    toHide() {
      this.util.toClientPath(0);
      this.isShow = false;
      this.noBack = true;
    },
    goHome() {
      let json = {};
      try {
        window.webkit.messageHandlers.goHome.postMessage(json); //ios
      } catch (err) {
        window.AppJs.goHome(); //android
      }
    },
    toLineFeed(str) {
      //让字符串换行
      // return str.replace(/\n|\r\n/g, "<br/>")
      return str.join(",");
    },
    getNewDetail() {
      let param = {
        productId: this.productId ? this.productId : "",
      };
      this.$get("/app/api/v1/union/product-detail", param)
        .then((res) => {
          if (res.code == 200) {
            this.util.title(res.data.name);
            this.newDetail = res.data;
          } else {
            _this.util.toast({ msg: res.message });
          }
        })
        .catch((error) => {});
    },
    //联登
    toLogin() {
      let json = {
        event_key: "h5_middlepage_bullet_click",
      };
      this.toCountPoint(json);
      if (
        this.newDetail.recommendBlacklist == 1 &&
        this.newDetail.hasBlackList == false &&
        this.showBlackTask == false
      ) {
        //是黑名单
        this.showBlackTask = true;
        this.showCheckWindow = true;
      } else {
        this.toLoginApi();
      }
    },
    toLoginApi() {
      this.showCheckWindow = false;
      let _this = this;
      _this.isShowLoading = true;
      let param = {
        productId: this.productId ? this.productId : "",
      };
      this.$post("/app/api/v1/union/login", param)
        .then((res) => {
          if (res.code == 200) {
            // _this.count(res.data.pageUrl);
            window.location.href = res.data.pageUrl;
          } else {
            _this.util.toast({ msg: res.message });
            // this.signInFail();//联登失败页面
          }
          _this.isShowLoading = false;
        })
        .catch((error) => {});
    },
    //统计埋点
    toCountPoint(json) {
      // Object.assign(this.commonParams, json)
      this.$get("/app/api/v1/newEventTrace", json)
        .then((res) => {
          if (res.code == 200) {
          } else {
            this.util.toast({ msg: res.message });
          }
        })
        .catch((error) => {});
    },
    //埋点
    count(url) {
      //pagePosition：新口子推荐位：6 广告位：7 首页产品：2
      let param = {
        type: 1,
        page: 4,
        url: url,
        pagePosition: 4,
        productType: "",
        productId: this.productId,
        gmtTimestamp: new Date().getTime(),
      };
      let _this = this;
      this.$post("/app/api/v1/event-tracking/push02", param)
        .then(function(res) {
          if (res.code == 200) {
            // window.location.href = url;
          } else {
            _this.util.toast({ msg: res.message });
          }
        })
        .catch(function(error) {});
    },
    //调用android和ios的方法
    signInFail() {
      let json = {
        productId: this.productId,
      };
      try {
        window.webkit.messageHandlers.signInFail.postMessage(json); //ios
      } catch (err) {
        window.AppJs.signInFail(JSON.stringify(json)); //android
      }
    },
  },
};
</script>
<style scoped>
.detail_box {
  background: #f7f7f7;
  width: 100%;
}
.header {
  background: url("../../assets/img/vip/detail_bg.png") no-repeat top center;
  background-size: 100% 100%;
  width: 100%;
  height: 1.28rem;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: space-between;
  padding: 0 0.4rem;
}
.h_title {
  font-size: 0.12rem;
  padding-top: 0.3rem;
  margin-bottom: 0.15rem;
  color: #fff;
}
.h_money {
  font-size: 0.26rem;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}
.plan {
  margin: 0.15rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  height: 0.8rem;
  margin-top: 0;
  position: relative;
  /* top: -0.4rem; */
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-bottom: 0.1rem;
  z-index: 10;
}

.product_tips {
  padding: 0 0.15rem;
  background: #fff;
  margin-bottom: 0.1rem;
}
.tips_flex {
  display: flex;
  justify-content: space-between;
  height: 0.5rem;
  align-items: center;
}
.tips_bot_border {
  border-bottom: 0.01rem solid #f5f5f5;
}
.tips_txt_color {
  color: #333333;
  font-size: 0.14rem;
}
.tips_num_color {
  color: #999999;
  font-size: 0.14rem;
}
.plan .item {
  flex: 1;
  text-align: center;
  padding: 0.18rem 0 0.15rem 0;
}
.p_title {
  color: #999;
  font-size: 0.12rem;
  margin-bottom: 0.1rem;
}
.p_info {
  color: #333;
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFangSC;
  font-weight: 500;
}
.p_line {
  width: 1px;
  height: 0.2rem;
  background: #eee;
  position: relative;
  top: 0.3rem;
}
.product,
.apply,
.loan {
  color: #666;
  font-size: 0.14rem;
  padding: 0.15rem;
  background: #fff;
  margin-bottom: 0.1rem;
  /* position: relative;
  top: -0.95rem; */
  /* padding-top: 0.55rem; */
}
.loan {
  padding-top: 0.15rem;
}
.com_title {
  font-size: 0.14rem;
  color: #333;
  margin-bottom: 0.15rem;
  font-family: PingFangSC-Medium, PingFangSC;
  font-weight: 500;
}
.line {
  width: 100%;
  height: 0.5rem;
}
.com_line {
  width: 3px;
  height: 0.12rem;
  background: #5175f1;
  display: inline-block;
  margin-right: 0.05rem;
  position: relative;
  top: -0.01rem;
}
.circle {
  display: inline-block;
  width: 0.03rem;
  height: 0.03rem;
  background: #000;
  border-radius: 50%;
  position: relative;
  top: -0.03rem;
  margin-right: 0.1rem;
}

.btn {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  color: #fff;
  height: 0.6rem;
  font-size: 0.17rem;
  line-height: 0.6rem;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  position: fixed;
  /* top: -0.8rem; */
  bottom: 0;
}
/* .btnBox {
  text-align: center;
  position: fixed;
  bottom: 0.25rem;
  left: 0;
  width: 100%;
}
@media screen and (width: 375px) and (height: 690px) {
  .btnBox {
    padding-bottom: 0.34rem;
  }
}
@supports (bottom: env(safe-area-inset-bottom)) {
  .btnBox {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
} */
.a_con {
  display: flex;
  flex: 1;
  justify-content: space-between;
  text-align: center;
}
.a_con .step {
  flex: 1;
  font-size: 0.12rem;
  color: #333;
}
.icon1,
.icon2,
.icon3,
.icon4 {
  display: inline-block;
  background: url("../../assets/img/vip/detail_icon1.png") no-repeat top center;
  background-size: 100% 100%;
  width: 0.3rem;
  height: 0.3rem;
  margin: 0 auto;
  margin-bottom: 0.08rem;
  text-align: center;
}
.icon2 {
  background: url("../../assets/img/vip/detail_icon2.png") no-repeat top center;
  background-size: 100% 100%;
}
.icon3 {
  background: url("../../assets/img/vip/detail_icon3.png") no-repeat top center;
  background-size: 100% 100%;
}
.icon4 {
  background: url("../../assets/img/vip/detail_icon4.png") no-repeat top center;
  background-size: 100% 100%;
}
.step_line {
  background: url("../../assets/img/vip/detail_line.png") no-repeat top center;
  background-size: 100% 100%;
  width: 0.33rem;
  height: 0.04rem;
  position: relative;
  top: 0.2rem;
}

/* 弹窗 */
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}
.toast {
  width: 2.75rem;
  height: 2rem;
  background: #fff;
  border-radius: 10px;
  z-index: 99;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.2rem 0.15rem;
}
.btn_box {
  clear: both;
  overflow: hidden;
}
.reject,
.submit {
  display: inline-block;
  width: 1.1rem;
  height: 0.34rem;
  background: #fff;
  border-radius: 3px;
  border: 1px solid #5175f1;
  color: #5175f1;
  text-align: center;
  line-height: 0.34rem;
}
.toast .item {
  margin: 0.15rem 0;
  background: #f5f5f5;
  padding: 0.15rem;
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.item div,
.item span {
  flex: 1;
}
.item .t_icon {
  background: url("../../assets/img/vip/detail_icon4.png") no-repeat top center;
  background-size: 100% 100%;
  margin-right: 0.1rem;
  width: 0.4rem;
  height: 0.4rem;
}
.item .t_icon img {
  width: 0.4rem;
  height: 0.4rem;
}
.item .money {
  color: #ee6c67;
  font-size: 0.16rem;
}
.submit {
  background: #5175f1;
  color: #fff;
  margin-left: 0.25rem;
}
.toast h1 {
  color: #333;
  font-size: 0.15rem;
  text-align: center;
}
</style>
